import React, { useState, useEffect } from "react";
import styled from "styled-components";
import moment from "moment";
import axios from "axios";
import { Table, Card, Row, Col, Button, Drawer } from "antd";
import { EditOutlined } from "@ant-design/icons";
import CreateEvent from "./components/CreateEvent";

const defaultSortOrder = ["descend", "ascend", "descend"];
const StyledTable = styled(Table)`
  table {
    border-spacing: 0 10px !important;
  }
  .ant-table-tbody > tr > td {
    border: none;
    padding: 12px 16px;
  }
  .ant-table-row {
    border-radius: 10px !important;
    box-shadow: 1px 1px 10px #1c3faa1a !important;
  }
  .ant-table-column-sorters {
    padding: 0;
  }
  .ant-pagination-item,
  .ant-pagination-item-link {
    border-radius: 50% !important;
  }
  .ant-pagination-item-active {
    border: none;
    background: #2680eb;
    a {
      color: white !important;
    }
  }
`;

const StyledDrawer = styled(Drawer)`
  .ant-drawer-close {
    position: absolute;
    box-shadow: 1px 1px 6px #00000029;
    border-radius: 50%;
    right: 20px;
    width: 35px;
    height: 35px;
    line-height: 0px;
  }
`;

const Events = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState("descend");
  const [refetch, setRefetch] = useState(false);
  const [tableData, setTableData] = useState(undefined);
  const [tableLoading, setTableLoading] = useState(false);
  const [drawerVisibility, setDrawerVisibility] = useState(false);
  const [rowData, setRowData] = useState(undefined);
  useEffect(() => {
    const api = "/api/Event/GetAllEvents";
    const request = {
      method: "GET",
    };
    setTableLoading(true);
    axios(api, request)
      .then((response) => {
        const { data } = response;
        setTableData(data);
        setTableLoading(false);
      })
      .catch((err) => {
        setTableLoading(false);
      });
  }, [refetch]);

  const CheckNull = (a, b, sortOrder) => {
    let initialItem = a ? a : sortOrder === "ascend" ? "z" : "a";
    let nextItem = b ? b : sortOrder === "ascend" ? "z" : "a";
    return [initialItem, nextItem];
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b, sortOrder) => {
        let values = CheckNull(a.name, b.name, sortOrder);
        return values[0].localeCompare(values[1]);
      },
      sortDirections: defaultSortOrder,
    },
    {
      title: "Group Name",
      dataIndex: "groupName",
      key: "groupName",
      sorter: (a, b, sortOrder) => {
        let values = CheckNull(a.groupName, b.groupName, sortOrder);
        return values[0].localeCompare(values[1]);
      },
      sortDirections: defaultSortOrder,
    },
    {
      title: "EventType Name",
      dataIndex: "eventTypeName",
      key: "eventTypeName",
      sorter: (a, b, sortOrder) => {
        let values = CheckNull(a.eventTypeName, b.eventTypeName, sortOrder);
        return values[0].localeCompare(values[1]);
      },
      sortDirections: defaultSortOrder,
    },
    {
      title: "Event Admin Name",
      dataIndex: "eventAdminName",
      key: "eventAdminName",
      sorter: (a, b, sortOrder) => {
        let values = CheckNull(a.eventAdminName, b.eventAdminName, sortOrder);
        return values[0].localeCompare(values[1]);
      },
      sortDirections: defaultSortOrder,
    },
    {
      title: "Sub Domain",
      dataIndex: "subDomain",
      key: "subDomain",
      sorter: (a, b, sortOrder) => {
        let values = CheckNull(a.subDomain, b.subDomain, sortOrder);
        return values[0].localeCompare(values[1]);
      },
      sortDirections: defaultSortOrder,
    },
    {
      title: "Start Date",
      key: "startDateTime",
      render: (val) => (val !== null ? moment(val).format("MM/DD/YYYY") : "--"),
      dataIndex: "startDateTime",
      sorter: (a, b) => moment(a.startDateTime).diff(b.startDateTime),
      sortDirections: defaultSortOrder,
    },

    {
      title: "End Date",
      key: "endDateTime",
      render: (val) => (val !== null ? moment(val).format("MM/DD/YYYY") : "--"),
      dataIndex: "endDateTime",
      sorter: (a, b) => moment(a.endDateTime).diff(b.endDateTime),
      sortDirections: defaultSortOrder,
    },
    {
      title: "Action",
      key: "action",
      render: (val) => (
        <>
          <Button
            type="primary"
            icon={<EditOutlined />}
            style={{ marginRight: "8px" }}
            onClick={() => (setDrawerVisibility(true), setRowData(val))}
          />
        </>
      ),
    },
  ];

  return (
    <>
      <Card>
        <Row type="flex" justify="space-between">
          <Col>
            <h2>Events</h2>
          </Col>
          <Row justify="end">
            <Col>
              <Button
                type="primary"
                onClick={() => (setDrawerVisibility(true), setRowData(undefined))}
              >
                Add New
              </Button>
            </Col>
          </Row>
        </Row>
        <StyledTable
          loading={tableLoading}
          dataSource={tableData}
          columns={columns}
          pagination={{
            pageSize: 10,
            current: currentPage,
            total: tableData === undefined ? 0 : tableData.length,
            defaultCurrent: 1,
          }}
          onChange={(pagination, filters, sorter) => {
            setCurrentPage(pagination.current);
            if (sorter.order !== order) {
              setOrder(sorter.order);
              setCurrentPage(1);
            }
          }}
        />
      </Card>
      <StyledDrawer
        title={rowData ? "Edit Event" : "Create Event"}
        destroyOnClose
        maskClosable={false}
        width={"40vw"}
        visible={drawerVisibility}
        onClose={() => setDrawerVisibility(false)}
      >
        <CreateEvent
          rowData={rowData}
          setRefetch={setRefetch}
          setDrawerVisibility={setDrawerVisibility}
        />
      </StyledDrawer>
    </>
  );
};

export default Events;
